<template>
    <div class="teacher-content-books">
        <!-- <div class="preview-hader-top clearfix">
			<p class="title-file-top">{{ docName }}</p>
		</div> -->
        <div class="PreviewLeft" v-show="ishideen"
            :class="{ maxleftwidth: docType == 1, caclheightmax: (docType != 2 && docType != 6) || diloagslt == true, caclheight: (docType == 2 || docType == 6) && diloagslt == true, mincaclheight: diloagslt == false, urlsourcewidth: docType == 7 }">
            <div class="bigimg">
                <div v-if="docType == 2" class="img-precol" style="text-align: center;overflow: auto;">
                    <div class="btn_pre-left-1" @click="lastimg()">
                        <i class="wl-icon-xiangzuo"></i>
                    </div>

                    <div class="btn_pre-right-1" @click="nextimg()">
                        <i class="wl-icon-xiangyou1"></i>
                    </div>
                    <div
                        style="width:100%;height:100%;overflow: hidden; background: rgb(50, 54, 57);box-sizing: border-box;">
                        <viewer :images="[imgurl]" :options="options" ref="viewers" v-if="isShow">
                            <img class="img-preleft" :src="imgurl" style="height:100%" v-show="false" />
                        </viewer>
                    </div>
                </div>
                <!-- <div v-if="docType == 2" class="img-precol" style="width:100%;height:100%">
					<div class="btn_pre-left-1" @click="lastimg()">
						<i class="wl-icon-xiangzuo"></i>
					</div>

					<div class="btn_pre-right-1" @click="nextimg()">
						<i class="wl-icon-xiangyou1"></i>
					</div>

					<img class="img-preleft" :src="imgurl" style="width:100%;margin-top:5%;" />
					<viewer :images="imgurl" :options="options" ref="viewers">
						<img class="img-preleft" :src="imgurl" style="max-width:100%;height:100%" v-show="false" />
					</viewer>
				</div> -->
            </div>
        </div>
        <el-row class="dialogimg" v-show="dialogVisible">
            <i @click="handleClose" style="color:white" class="el-icon-close icon-closeimg"></i>
            <!-- <el-col class="allimg-col" v-for="(item, index) in pptImages" :key="index">
				<img v-if="item != ''" class="allimg-img" @click="isimg(item, index)" :src="item" alt />
				<img v-if="item == ''" class="allimg-img" @click="isimg(item, index)" :src="pptImages[0]" alt />
			</el-col> -->
        </el-row>
        <el-row class="zzrow" v-show="dialogVisible"></el-row>
        <div class="page-number-center" v-if="docType == 2">
            <div class="btn_pre-left" @click="lastimg()">
                <i class="el-icon-arrow-left"></i>
            </div>
            <h3 class="page-number-count">{{ nameActive + 1 }}/{{ pptImages.length }}</h3>
            <div class="btn_pre-right" @click="nextimg()">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <!-- <div class="page-number-center">
            <div class="btn_pre-left" v-if="(docType == 2 || docType == 6) && bottommenu && type != 'xls' && type != 'xlsx'"
                @click="lastimg()">
                <i class="wl-icon-xiangzuo"></i>
            </div>
            <div class="btn_pre-fd" @click="fangda()" v-if="docType == 1">
                +
            </div>
            <h3 v-if="(docType == 2 || docType == 6) && bottommenu && type != 'xls' && type != 'xlsx'"
                class="page-number-count">{{ nameActive + 1 }}/{{ pptImages.length }}</h3>
            <div class="btn_pre-right"
                v-if="(docType == 2 || docType == 6) && bottommenu && type != 'xls' && type != 'xlsx'" @click="nextimg()">
                <i class="wl-icon-xiangyou1"></i>
            </div>
            <div class="btn_pre-sx" @click="suoxiao()" v-if="docType == 1">
                -
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'PreparingCourseware',
    data() {
        return {
            isShow: false,
            downFile: '',
            faceTeach: {
                Id: '',
                ClassId: '',
            },
            pptImages: [],
            imgurl: [],
            images: [],
            options: {
                inline: true,
                button: false,
                navbar: false,
                toolbar: false,
                title: false,
                initialCoverage: 1
            },
            nameActive: 0,
            dialogVisible: false,
            changestate: false,
            ishideen: true,
            docType: 0,
            type: 0,
            isheight: 0,
            offeceUrl: '',
            pptpageindex: 1,
            currentPageIndex: 1,
            diloagslt: false,
            faceTeachList: [],
            dialogVisibleFaceTeach: false,
            facePagination: {
                totalCount: 10,
                pageSize: 6,
                pageIndex: 1,
            },
            faceTeachId: '',
            classList: [],
            faceClassId: '',
            faceName: '',
            fileSourceId: '',
            route: 0,
            pinchImg: null,
            docName: '',
        };
    },
    props: {
        fileList: {
            type: Array,
            defaut: [],
        },
        bottommenu: {
            type: Boolean,
            default: true,
        },
        sourceId: {
            type: String,
            default: '',
        },
        courseId: {
            type: String,
            default: '',
        },
    },
    computed: {
        viewer() {
            return this.$refs.viewer && this.$refs.viewer.$viewer;
        },
    },
    created() {
        console.log(this.sourceId);
        this.fileSourceId = this.sourceId;
        this.previewImage();
    },

    mounted() {
        //课件的页面事件
        // window.addEventListener('message', e => {
        // 	if (typeof e.data == 'string') {
        // 		var data = JSON.parse(e.data).payload;
        // 		if (data >= 0) {
        // 			this.currentPageIndex = data + 1;
        // 			this.nameActive = data;
        // 		}
        // 	}
        // });
        // this.$nextTick(() => {
        //     // 禁止右键
        //     document.oncontextmenu = new Function('event.returnValue=false');
        //     // 禁止F12
        //     document.onkeydown = document.onkeyup = document.onkeypress = function (event) {
        //         var e = event || window.event || arguments.callee.caller.arguments[0];
        //         if (e && e.keyCode == 123) {
        //             e.returnValue = false;
        //             return false;
        //         }
        //     };
        //     // document.onkeydown = new Function("event.returnValue=false");
        // });
    },
    methods: {
        pinch(evt) {
            debugger;
            this.pinchImg = document.getElementById('pinchImg');
            Transform(this.pinchImg);
            var initScale = 1;
            this.pinchImg.scaleX = this.pinchImg.scaleY = initScale * evt.zoom;
        },
        pressMove(evt) {
            this.pinchImg = document.getElementById('pinchImg');
            Transform(this.pinchImg);
            this.pinchImg.translateX += evt.deltaX;
            this.pinchImg.translateY += evt.deltaY;
            evt.preventDefault();
        },
        fangda() {
            this.viewer.zoom(1);
            // this.viewers.zoom(1);
        },
        suoxiao() {
            this.viewer.zoom(-1);
            // this.viewers.zoom(-1);
        },
        rotate() {
            this.viewer.rotate(90);
        },
        nextFile() {
            var index = this.fileList.indexOf(this.fileSourceId);
            if (this.fileList.length > index + 1) {
                index += 1;
                this.fileSourceId = this.fileList[index];
                this.pptImages = [];
                this.previewImage();
            }
        },
        lastFile() {
            var index = this.fileList.indexOf(this.fileSourceId);
            if (0 < index) {
                index -= 1;
                this.fileSourceId = this.fileList[index];
                this.pptImages = [];
                this.previewImage();
            }
        },

        slt() {
            this.diloagslt = !this.diloagslt;
        },
        back() {
            this.$emit('dialogVisiblePreviewResources', false);
        },
        gotopage(pageindex) {
            var jsonObj = {
                type: 'Goto',
                payload: pageindex,
            };
            var msg = JSON.stringify(jsonObj);
            document.getElementById('pptiframe').contentWindow.postMessage(msg, '*');
        },
        lastimg() {
            debugger
            if (this.nameActive > 0 && this.docType != 6) {
                this.nameActive = parseInt(this.nameActive) - 1;
                this.imgurl = this.pptImages[this.nameActive];
                this.images = [this.imgurl];
                this.pptpageindex = this.pptpageindex - 1;
            } else {
                this.$message.warning('已经是第一页！')
            }
            if (this.docType == 6 && this.currentPageIndex > 1) {
                this.preAnim();
            }
        },
        nextimg() {
            if (this.nameActive < this.pptImages.length - 1 && this.docType != 6) {
                this.nameActive = parseInt(this.nameActive) + 1;
                this.imgurl = this.pptImages[this.nameActive];
                this.images = [this.imgurl];
                this.pptpageindex = this.pptpageindex + 1;
            } else {
                this.$message.warning('已经是最后一页！')
            }
            if (this.docType == 6 && this.currentPageIndex < this.pptImages.length) {
                this.nextAnim();
            }
        },
        preAnim() {
            var jsonObj = {
                type: 'PrevSlide',
            };
            var msg = JSON.stringify(jsonObj);
            document.getElementById('pptiframe').contentWindow.postMessage(msg, '*');
            if (this.pptpageindex > 1 && this.docType != 6) {
                debugger;
                this.pptpageindex = this.pptpageindex - 1;
            } else if (this.docType != 6) {
                this.pptpageindex = 1;
            }
        },
        nextAnim() {
            var jsonObj = {
                type: 'NextSlide',
            };
            var msg = JSON.stringify(jsonObj);
            document.getElementById('pptiframe').contentWindow.postMessage(msg, '*');
            if (this.pptpageindex < this.pptImages.length && this.docType != 6) {
                this.pptpageindex = this.pptpageindex + 1;
            } else if (this.docType != 6) {
                this.pptpageindex = this.pptImages.length;
            }
        },
        exitblowup() {
            this.changestate = false;
            this.ishideen = true;
        },
        onchangestate() {
            this.changestate = true;
            this.ishideen = false;
        },
        onchangelook() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.dialogVisibleFaceTeach = false;
        },
        isimg(val, index) {
            if (this.docType == 6) {
                this.gotopage(index + 1);
                this.currentPageIndex = index + 1;
                this.nameActive = index;
            } else {
                this.nameActive = index;
                this.pptpageindex = index + 1;
                this.imgurl = val;
                this.images = [this.imgurl];
            }
            this.dialogVisible = false;
        },
        getPictureList() {
            var img = new Image();
            var that = this;
            this.$http
                .post('/api/XOrg/OssSign/getPictureList', {
                    id: this.sourceId,
                })
                .then(res => {
                    if (!res.list) {
                        // this.$message("稍等文件未转换完成！");
                    } else {
                        for (let i = 0; i < res.list.length; i++) {
                            that.pptImages.push(res.list[i].picpath);
                        }
                        that.imgurl = this.pptImages[this.nameActive];
                        that.images = [that.imgurl];
                        img.src = that.imgurl;
                        that.isShow = true;
                        img.onload = function () {
                            if (img.width > img.height) {
                                that.isheight = 1;
                            } else {
                                that.isheight = 2;
                            }
                        };
                    }
                });
        },
        previewImage() {
            this.$http
                .post('/api/XOrg/TextBookSourceInfo/getNewCourseWareInfo', {
                    courseWareId: this.sourceId,
                })
                .then(rst => {
                    if (rst.code > 0) {
                        this.docName = rst.docName;
                        this.downFile = rst.docPriviewUrl + '?response-content-disposition=attachment;filename=' + rst.docName;
                    }
                    if (rst.status === -1) {
                        // Message.warning("文件转换失败不能预览");
                    } else if (rst.status === -2) {
                        // Message.warning("文件正在转换请稍后预览");
                    } else if (rst.status === 1) {
                        this.docType = rst.docType;
                        this.type = rst.type;
                        if (rst.docType === 2) {
                            this.getPictureList();
                        }
                    }
                });
        },
    },
};
</script>

<style lang="scss">
.urlsourcewidth {
    width: 100%;
}

.pptwidth {
    width: 80%;
}

.pptpageindexcolor {
    background-color: #409eff;
}

.teacher-content-books {
    overflow: hidden;
    height: 100%;
    width: 100%;

    .img_one {
        max-width: 88%;
        vertical-align: middle;
    }

    .img_two {
        max-height: 100%;
        vertical-align: middle;
    }

    .back_btn {
        background: #ff0000;
    }

    .btn_pre {
        background: white;
        margin: 10px;
    }

    .floatleft {
        float: left;
    }

    .maxleftwidth {
        width: 100%;
    }

    .minleftwidth {
        width: 80%;
    }

    .nameActive {
        background-color: #409eff;
    }

    .caclheight {
        height: 100%;
    }

    .mincaclheight {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .caclheightmax {
        height: 100%;
    }

    .PreviewLeft {
        .bigimg {
            position: relative;
            height: 100%;
            border: 1px solid #ccc;
            box-sizing: border-box;

            .img-precol {
                width: 1200px;
                // height: 1090px;
                height: 750px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .img-preleft {
                margin: 0 auto;
            }

            height: 100%;
        }
    }

    .video-player {
        width: 100%;
        height: 100% !important;

        .video-player {
            height: 100% !important;
        }

        // .vjs-big-play-button {
        //     border-radius: 50% !important;
        //     height: 70px !important;
        //     width: 70px !important;
        //     margin-left: -35px;
        // }

        .vjs-poster {
            background-size: 100% !important;
        }

        .video-js {
            height: 100% !important;
        }

        .video-poster {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 100%;
            height: 100%;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.4);
        }

        video {
            width: 100%;
            height: 100%;
            // object-fit: fill;
        }
    }

    .PreviewRight {
        width: 100%;
        height: 150px;

        // float: right;
        // border:2px solid #0F5858;
        .btn-imgpre {
            margin-top: 20px;
        }

        .PreviewRight-top {
            .imglistcol {
                // float:left;
                float: none;
                display: inline-block;
                border-radius: 5%;
                height: 100%;
                width: 140px;
                border: 1px solid grey;
                margin-left: 2%;
                padding: 5px;

                .img {
                    width: 100%;
                    height: 100%;
                }
            }

            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            height: 97%;
            width: 100%;
            margin-bottom: 10px;
        }

        .PreviewRight-bottom {
            position: fixed;
            right: 30px;
            bottom: 30px;
            width: 100%;
            text-align: right;
        }
    }

    .dialogimg {
        .allimg-col {
            .allimg-img {
                width: 100%;
                height: 100%;
            }

            float: left;
            width: 210px;
            height: 150px;
            margin: 10px;
        }

        .zzrow {
            width: 150%;
            height: 100%;
            position: fixed;
            top: 0;
            left: -100px;
            background-color: black;
            opacity: 0.9;
            z-index: 300000000;
        }

        .imgblowup {
            .blowupimg {
                .innerimg {
                    width: 100%;
                    height: 70px;
                    z-index: 200000001;
                    position: fixed;
                    bottom: 0px;
                    margin-left: 40%;
                }

                width: 100%;
                height: 100%;
            }

            position: relative;
            top: 0px;
            width: 100%;
            background-color: grey;
            z-index: 200000000;
        }

        .icon-closeimg {
            size: 26px;
            position: fixed;
            top: 20px;
            right: 20px;
            font-size: 35px;
            cursor: pointer;
            font-weight: bolder;
        }

        z-index: 200000001;
        overflow: auto;
        cursor: pointer;
        position: fixed;
        top: 15%;
        left: 25%;
        height: 600px;
        width: 960px;
    }

    .btn_pre-left-1 {
        position: absolute;
        // background: rgba(255, 154, 160,0.5);
        background: #154c95;
        color: #fff;
        font-size: 32px;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-radius: 100%;
        left: 2%;
        cursor: pointer;
        opacity: 0.3;
        z-index: 9999;
        bottom: 0;
        top: 0;
        margin: auto;

        &:hover {
            opacity: 1;
        }
    }

    .btn_pre-right-1 {
        position: absolute;
        background: #154c95;
        color: #fff;
        font-size: 32px;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-radius: 100%;
        right: 2%;
        opacity: 0.3;
        cursor: pointer;
        z-index: 9999;
        bottom: 0;
        top: 0;
        margin: auto;

        &:hover {
            opacity: 1;
        }
    }

    .page-number-center {
        position: absolute;
        text-align: center;
        width: 100%;
        line-height: 40px;
        width: 1200px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border-top: 1px solid #ccc;
        font-size: 18px;

        .page-number-count {}

        .btn_pre-left {
            margin-right: 80px;
            background: #154c95;
            color: #fff;
            font-size: 12px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 100%;
            cursor: pointer;
        }

        .btn_pre-right {
            margin-left: 80px;
            background: #154c95;
            color: #fff;
            font-size: 12px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 100%;
            cursor: pointer;
        }
    }
}</style>